import axios from 'axios';
import path from 'path';
import { pull } from 'lodash';
import sanitizeHTML from 'sanitize-html';
import {
    GETTERS as localeGetters,
    MODULE_NAME as localeStoreName,
} from '@shared/locale/store';
import { API_PREFIX } from '@shared/globals';

export const ACTIONS = {
    LOAD_DATA_PRIVACY: 'loadDataPrivacy',
};
export const MUTATIONS = {
    SET_DATA_PRIVACY: 'setDataPrivacy',
};

let api = axios.create({
    baseURL: `/${API_PREFIX}/static/config`,
    headers: {},
    withCredentials: true,
});

const sanitizeHTMLOpts = {
    allowedAttributes: { '*': ['class', 'type'] },
    allowedTags: pull(sanitizeHTML.defaults.allowedTags, 'a'),
};

export default {
    name: 'dataPrivacy',
    namespaced: true,
    state: {
        dataPrivacy: '',
    },
    mutations: {
        setDataPrivacy(state, dataPrivacy) {
            state.dataPrivacy = sanitizeHTML(dataPrivacy, sanitizeHTMLOpts);
        },
    },
    getters: {
        getDataPrivacy(state) {
            return state.dataPrivacy;
        },
        // remove values to interpolate, we just want text.
        getStaticDataPrivacy(state) {
            return state.dataPrivacy.replace(/{{.*}}/g, '');
        },
    },
    actions: {
        loadDataPrivacy({ rootGetters, commit }) {
            let country =
                    rootGetters[
                        localeStoreName + '/' + localeGetters.GET_COUNTRY_CODE
                    ],
                locale =
                    rootGetters[localeStoreName + '/' + localeGetters.GET_LOCALE];
            return api
                .get(path.join('data-privacy', country, locale))
                .then((payload) => {
                    let dataPrivacy = payload.data;
                    commit(MUTATIONS.SET_DATA_PRIVACY, dataPrivacy);
                    return dataPrivacy;
                });
        },
    },
};



// WEBPACK FOOTER //
// ./shared/store/modules/dataprivacy.js